function Spinner() {
    return (<div className="loader flex mt-72 items-center justify-center">

    </div>)
}
export default Spinner;